const achievements = [
  {
    title: "Top 1 Best Computer Science Graduate - CS UI 2021/1",
    period: "Jan 2021",
    content: "Graduated Cum Laude with the highest GPA of the year: 3.97 / 4.00 - Computer Science Major, University of Indonesia.",
    isActive: true,
    onDisplay: true,
  },
  {
    title: "Masterpiece Product",
    period: "Jul 2020",
    content: "Won on the team product TBCare. During the development period, achieved 2 times best article of the sprint and 3 times product of the sprint (out of 5 sprints in total).",
    isActive: true,
    onDisplay: true,
  },
  {
    title: "IT Dev Best Staff",
    period: "Dec 2018",
    content: "I integrated a LINE bot to our room rental system, developed database modelling of a file sharing system, and mentored ~15 freshmen in an introductory class to IT Dev.",
    isActive: true,
    onDisplay: true,
  },
  {
    title: "Software Engineering Academy Best Team",
    period: "Jul 2018",
    content: "Selected as one of 20 participants out of 500+ candidates. Collaborated in a winning team project: GO-FEED – a GO-FOOD simulator.",
    isActive: true,
    onDisplay: true,
  },
];
  
export default achievements;
